module.exports = "/images/Romania.png?36fb46d3b0accfdf33ecbc7d3d70f2b4";